module.exports = __webpack_public_path__ + "img/consult_info2.2d4a3f8e.png";